import { Component, OnInit } from '@angular/core'
import { GlobalService } from '../../../services/global.service'

@Component({
    selector: 'app-enterprise-header',
    templateUrl: './enterprise-header.component.html',
    styleUrls: ['./enterprise-header.component.scss'],
})
export class EnterpriseHeaderComponent implements OnInit {
    enterpriseKey: string = 'parkupp'

    constructor(public globalService: GlobalService) {
        this.enterpriseKey = globalService.enterpriseKey
    }

    ngOnInit(): void {}
}

